import { render, staticRenderFns } from "./create_order_type.vue?vue&type=template&id=47954b2f&"
import script from "./create_order_type.vue?vue&type=script&lang=js&"
export * from "./create_order_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports